module.exports = "https://bce.bdstatic.com/video-meeting/zh-cn/assert/browser.d8d46362.png";